// Single Region Page (CPT `region_pages`) — guarded so it only runs on single-region_pages.php.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.single-region');
    if (!root) {
        return;
    }

    // Плавный скролл по внутренним якорям контента региональной страницы.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});
